<main class="agTable agComponent">
  <div id="myGrid" class="ag-theme-material tableContainer">
    <!-- Skeleton -->

    <!-- Table -->
    <ag-grid-angular
      id="myTable"
      class="ag-theme-custom tableContent"
      [ngClass]="{ 'fade-in': !this.skeleton, 'hide-scroll': rowData.length <= 1 }"
      style="width: 100%; height: 100%"
      [gridOptions]="gridOptions"
      [defaultColDef]="defaultColDef"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="tooltipShowDelay"
      [tooltipHideDelay]="tooltipHideDelay"
      [pinnedBottomRowData]="pinnedBottomRowData"
      [ensureDomOrder]="true"
      [suppressRowVirtualisation]="true"
      [suppressColumnVirtualisation]="false"
      [enableCellTextSelection]="true"
      [masterDetail]="true"
      [detailCellRendererParams]="detailCellRendererParams"
      [domLayout]="domLayout"
      [animateRows]="true"
      [rowData]="rowData"
      [pagination]="pagination"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (cellClicked)="onCellClicked($event)"
    ></ag-grid-angular>
  </div>
</main>
